import { render } from "./CommentSupport.vue?vue&type=template&id=472fbd20&scoped=true"
import script from "./CommentSupport.vue?vue&type=script&lang=js"
export * from "./CommentSupport.vue?vue&type=script&lang=js"

import "./CommentSupport.vue?vue&type=style&index=0&id=472fbd20&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472fbd20"]])

export default __exports__